// extracted by mini-css-extract-plugin
export var checkboxGroupSpacing = "components-forms-__Checkbox-module___checkboxGroupSpacing";
export var checkboxIcon = "components-forms-__Checkbox-module___checkboxIcon";
export var container = "components-forms-__Checkbox-module___container";
export var iconWrapper = "components-forms-__Checkbox-module___iconWrapper";
export var input = "components-forms-__Checkbox-module___input";
export var labelText = "components-forms-__Checkbox-module___labelText";
export var labelWrapper = "components-forms-__Checkbox-module___labelWrapper";
export var locked = "components-forms-__Checkbox-module___locked";